import React, { useState, useContext, createRef, useEffect } from 'react';
import { Header, Checkbox, Container, Segment, Sticky, Grid, Input, Transition, Divider, Loader } from 'semantic-ui-react';
import { Button, Form, Icon, Message } from 'semantic-ui-react';
import { Link, Redirect } from 'react-router-dom';
import { AppState } from '../../context';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/functions';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import { dbFamMember, dbCaregivers, dbTasks } from '../../firebase';


const LoginF = () => {
  const someContext = useContext(AppState);
  const [error, setError] = useState(false);
  const [pass, setPass] = useState("");
  const [username, setUsername] = useState("");
  const {
    familyMembers,
    setFirsttimeuser,
    setUser,
    logged,
    setLogged
  } = someContext;
  const contextRef = createRef();

  useEffect(() => {
    firebase.auth().onAuthStateChanged(function (val) {
      if (val) {
        dbFamMember.orderByChild("id").equalTo(val["uid"]).once("value", snapshot => {
          if (snapshot.exists()) {
            const userData = snapshot.val();
            setFirsttimeuser(false)
          }
          else {
            setFirsttimeuser(true)
          }
        })
      }
      setUser(val)

    });
  }, []);


  const PageHeader = () => {
    return (
      <Segment
        basic
        style={{ backgroundColor: "#006990", textAlign: "center", marginBottom: "0px" }}
        fluid="true"
      >
        <Grid columns={2}>
          <Grid.Column width='3' />
          <Grid.Column width='10'>
            <Header
              as={Link}
              to="/"
              inverted
              content="Homecare"
              size="large"
              color="black"
              style={{ cursor: "default" }}
            />
          </Grid.Column>
        </Grid>
      </Segment>
    );
  };

  function CheckPass(pass, username) {
    if (familyMembers[username])
    {
      if(familyMembers[username]["password"] === pass && familyMembers[username]["type"] === "secondary")
      {
        setLogged(true);
        
      }
      else if(pass && username){
        setError(true)}
    }
    else if(pass && username){
      setError(true)}
  };
  return (
    <div ref={contextRef}>
      <Sticky context={contextRef} >
        <PageHeader />
        <Grid padded textAlign="center">
          <Divider hidden />
          
          <Grid.Row>
            <Form size="large" warning={error}>
              <Form.Group>
                <Form.Input
                required={true}
                  onChange={(e) => { setUsername({ value: e.target.value }) }}
                  id='form-subcomponent-shorthand-input-first-name'
                  label='Username:'
                />
                
              </Form.Group>
              <br/>
              <Form.Group>
                <Form.Input
                required={true}
                  onChange={(e) => { setPass({ value: e.target.value }) }}
                  id='form-subcomponent-shorthand-input-first-name'
                  label='Password:'
                  type="password"
                />
                
              </Form.Group>
              <Form.Button style={{ marginLeft: "30px", marginTop: "30px" }} size="big" color='green' icon labelPosition='right' onClick={() => CheckPass(pass.value, username.value)}>
                Login
          <Icon name='checkmark' />
              </Form.Button>
              <div style={{width:"200px"}}>
              <Message
                warning
                floating
                content="Incorrect username or password."
                size="tiny"
              />
              </div>
            </Form>

          </Grid.Row>
        </Grid>
        {logged && username? <Redirect to={`/viewfamily/${username.value}`} push={true} />: ""}
      </Sticky>
    </div>
  );
};

export default LoginF;